import React, {useState, useEffect} from 'react';
import {connect} from "react-redux";
import withHeader from "../../../hocs/withHeader";
import {withToastManager} from "react-toast-notifications";
import {withRouter} from 'react-router-dom';
import queryString from "query-string";
import AuthenticationService from "../../../../services/Authentication/AuthenticationService";

function ConfirmAccount(props) {

    const urlParams = queryString.parse(props.location.search);

    if(typeof urlParams.user_id === "undefined") {
        props.history.push("/register");
    }

    const countDownTimeInSeconds = 30;

    const [triggerCountDown, updateTriggerCountDown] = useState(true);
    const [countDown, updateCountDown] = useState(countDownTimeInSeconds);
    const [intervalId, updateIntervalId] = useState(false);
    const [resendBtnDisabled, updateResendBtnDisabled] = useState(true);

    useEffect(() => {
        if(triggerCountDown) {
            const id = setInterval(() => {
                updateCountDown(countDown => countDown - 1);
            }, 1000);
            updateIntervalId(id);
            return () => {
                clearInterval(id)
            }
        }
    }, [triggerCountDown]);

    if(countDown === -1) {
        clearInterval(intervalId);
        updateTriggerCountDown(false);
        updateResendBtnDisabled(false);
        updateCountDown(0);
    }

    function handleResendEmail(event) {
        event.preventDefault();
        AuthenticationService.sendActivationEmail(urlParams.user_id,
            (success) => {
                props.toastManager.add("Success! Activation email has been resent!", {
                    appearance: 'success'
                });
            },
            (error) => {
                props.toastManager.add("Error! Cannot resend activation email!", {
                    appearance: 'error'
                });
            });
        updateResendBtnDisabled(true);
        updateCountDown(countDownTimeInSeconds);
        updateTriggerCountDown(true);
    }

    const resendBtnClassName = "cta--normal cta--notransform " + (resendBtnDisabled ? "cta--soft-disabled" : "");

    return (
        <section className="confirm-account">
            <div className="container">
                <h2 className="pt-xlg pb-xl">We sent you an email. Please check your inbox to activate your account.</h2>
                <div className="cta__wrapp pv-xlg">
                    <button
                        onClick={handleResendEmail}
                        disabled={resendBtnDisabled}
                        className={resendBtnClassName}>{resendBtnDisabled ? "Activation email sent" : "Resend activation email"}</button>
                    {countDown !== 0 &&
                        (<span className="recovery_timer">0:{countDown < 10 ? "0" + countDown : countDown}</span>)
                    }
                </div>
            </div>
        </section>
    )
}

const mapDispatchToProps = {};

export default connect(null, mapDispatchToProps)(withHeader(withRouter(withToastManager(ConfirmAccount))));